var _excluded = ["onIncrementButtonClick", "onDecrementButtonClick", "isDecrementButtonDisabled", "isIncrementButtonDisabled", "onBlur", "onChange", "onClear", "value", "backgroundColor", "isBig"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var ClearXIcon = function ClearXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m10 9.322 4.124-4.125 1.179 1.179-4.125 4.125 4.125 4.124-1.179 1.179L10 11.679l-4.125 4.125-1.179-1.179 4.125-4.124-4.125-4.125 1.179-1.179L10 9.322Z",
    fill: "#000",
    fillOpacity: ".7"
  }));
};
ClearXIcon.defaultProps = {
  width: "20",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import IconButtonAtm from "../../atoms/IconButtonAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import PushOrg from "../../organisms/PushOrg";
import ButtonQuark from "../../quarks/Button";
var inputWidthSpace = 6;
var inputHeightSpace = 3;
var inputBigVariantHeightSpace = 4;
var buttonSizeSpace = 3;
var buttonBigVariantSizeSpace = 4;
var borderWidth = 1;
var borderRadius = "large";
var Wrapper = styled.div.withConfig({
  componentId: "sc-ru4sdy-0"
})(["display:flex;min-width:fit-content;overflow:hidden;align-items:center;"]);
var Button = styled(ButtonQuark).withConfig({
  componentId: "sc-ru4sdy-1"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $isDisabled = _ref.$isDisabled,
    theme = _ref.theme,
    $backgroundColor = _ref.$backgroundColor,
    $isBig = _ref.$isBig,
    $isLeft = _ref.$isLeft;
  return css(["", ";display:flex;align-items:center;justify-content:center;width:", ";height:", ";background-color:", ";border:", " solid ", ";cursor:", ";border-radius:", ";padding:", ";", " ", " &:hover{background-color:", ";}"], cssTextAtm({
    typography: "medium4_s",
    onColor: $onColor,
    emphasis: $isDisabled ? "low" : "high"
  }), space(buttonSizeSpace), space(buttonSizeSpace), $backgroundColor || getColor(theme, "backgroundDarkLight"), unit(borderWidth), getBorderColor(theme, $onColor, "extraLow"), $isDisabled && "initial", getBorderRadius(theme, borderRadius), space(0.5), $isBig ? css(["width:", ";height:", ";padding:", ";"], space(buttonBigVariantSizeSpace), space(buttonBigVariantSizeSpace), space(1)) : null, $isLeft ? css(["margin-right:", ";"], space(0.5)) : css(["margin-left:", ";"], space(0.5)), $backgroundColor || getBorderColor(theme, "backgroundLight", "extraLow"));
});

/**
 * 1. Style needed to hide spinners which appear as default on input type="number"
 * https://stackoverflow.com/questions/23372903/hide-spinner-in-input-number-firefox-29
 * */

/* stylelint-disable property-no-vendor-prefix */
var Input = styled.input.withConfig({
  componentId: "sc-ru4sdy-2"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme,
    $backgroundColor = _ref2.$backgroundColor,
    $isBig = _ref2.$isBig;
  return css(["", ";width:", ";height:", ";padding:0;background-color:", ";border:", " solid ", ";text-align:center;border-radius:", ";padding:", " 0;-moz-appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}", " &:hover{border:", " solid ", ";}"], cssTextAtm({
    typography: "small3",
    onColor: $onColor
  }), space(inputWidthSpace), space(inputHeightSpace), getColor(theme, "backgroundLight"), unit(borderWidth), $backgroundColor || getBorderColor(theme, $onColor, "extraLow"), getBorderRadius(theme, borderRadius), unit(2), $isBig ? css(["height:", ";padding:", " 0;"], space(inputBigVariantHeightSpace), unit(6)) : null, unit(borderWidth), $backgroundColor || getBorderColor(theme, $onColor, "low"));
});
function NumberInputMol(_ref3) {
  var onIncrementButtonClick = _ref3.onIncrementButtonClick,
    onDecrementButtonClick = _ref3.onDecrementButtonClick,
    isDecrementButtonDisabled = _ref3.isDecrementButtonDisabled,
    isIncrementButtonDisabled = _ref3.isIncrementButtonDisabled,
    onBlur = _ref3.onBlur,
    onChange = _ref3.onChange,
    onClear = _ref3.onClear,
    value = _ref3.value,
    backgroundColor = _ref3.backgroundColor,
    isBig = _ref3.isBig,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Wrapper, restProps, /*#__PURE__*/React.createElement(Button, {
    onClick: onDecrementButtonClick,
    $onColor: onColor,
    $backgroundColor: backgroundColor,
    $isDisabled: !!isDecrementButtonDisabled,
    tabIndex: 0,
    $isBig: isBig,
    $isLeft: true
  }, "-"), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    $onColor: onColor,
    $backgroundColor: backgroundColor,
    $isBig: isBig
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onIncrementButtonClick,
    $onColor: onColor,
    $backgroundColor: backgroundColor,
    $isDisabled: !!isIncrementButtonDisabled,
    $isBig: isBig,
    tabIndex: 0
  }, "+"), onClear ? /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 1
  }, /*#__PURE__*/React.createElement(IconButtonAtm, {
    onClick: function onClick() {
      return onClear();
    },
    icon: ClearXIcon,
    sizeSpace: 2.5,
    hasDisabledTouchTargetSpace: true
  })) : null);
}
export default NumberInputMol;